import { Component } from '@angular/core';
import { OneSignalService } from './core/services/one-signal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private os: OneSignalService) {}

  ngOnInit() {
    if (location.hostname != 'localhost') {
      this.os.onInit();
      console.log(this.os);
    }
  }
}
